import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getCookie } from '@chilecompra/react-kit'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import ConfigProviderContainer from '../containers/ConfigProvider/ConfigProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import QuoteCreationHeadingContainer from '../containers/QuoteCreationHeading/QuoteCreationHeading.container'
import QuoteStepOneContainer from '../containers/QuoteStepOne/QuoteStepOne.container'
import QuoteSaveDraftDialog from '../containers/QuoteSaveDraftDialog/QuoteSaveDraftDialog.container'
import QuoteErrorDraftDialog from '../containers/QuoteErrorDraftDialog/QuoteErrorDraftDialog.container'
import QuoteNotification from '../containers/QuoteNotification/QuoteNotification.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import routes from '../config/settings/routes'
import { Grid } from './QuoteStepOne.styles'

/**
 * The Quote's page.
 */
const QuoteStepOne = () => {
  const navigate = useNavigate()

  const heading = {
    breadcrumbs: [
      {
        text: 'Escritorio',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Compra ágil',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Crear formulario'
      }
    ],
    step: 'PASO 1 DE 2',
    title: 'Crear Compra Ágil',
    description:
      'Una vez publicada, esta compra estará disponible para la participación de las Empresas de Menor Tamaño (EMT).',
    disclaimers: [<QuoteNotification key="cancelled-auto" />]
  }

  return (
    <AuthorizationProviderContainer>
      <ConfigProviderContainer>
        <BrandLayout featured={<QuoteCreationHeadingContainer {...heading} />}>
          <Grid container>
            <Grid item xs={12} md={8}>
              <QuoteStepOneContainer />
              <QuoteSaveDraftDialog />
              <QuoteErrorDraftDialog />
            </Grid>
          </Grid>
          <OnboardingDialogContainer />
        </BrandLayout>
      </ConfigProviderContainer>
    </AuthorizationProviderContainer>
  )
}

export default QuoteStepOne
